import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { from, map, Observable } from 'rxjs';
import { UserService } from '../user/user.service';

type AuthGuardResult =
  | boolean
  | UrlTree
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>;

@Injectable({
  providedIn: 'root',
})
export class SuperAdminGuardService {
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);


  public canActivate(state: RouterStateSnapshot): AuthGuardResult {
    return from(this.userService.isAuthenticated()).pipe(
      map((isAuthenticated) => {
        if (!isAuthenticated) {
          // Not authenticated, redirect to login
          return this.router.createUrlTree(['/login'], {
            queryParams: { return: state.url },
          });
        }

        // Check if user is super admin
        if (!this.userService.isSuperAdmin()) {
          // Not a super admin, redirect to main page with error
          console.warn('Access denied: User is not a super admin');
          return this.router.createUrlTree(['/']);
        }

        return true;
      })
    );
  }

  public canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): AuthGuardResult {
    return this.canActivate(state);
  }
}
